<template>
  <account-description :title="$t('targeting.info')">
    <span>{{ $t('targeting.info.page.description.p1') }}</span>
    <router-link to="/targeting">{{ $t('targeting.info.page.description.p2') }}</router-link>
    <span>{{ $t('targeting.info.page.description.p3') }}</span>
  </account-description>
</template>

<script>
import AccountDescription from '@/components/account/AccountDescription.vue';

export default {
  components: {
    AccountDescription,
  },
};
</script>
